import { get } from "lodash-es";
import React from "react";
import Button from "../Button";

const ExcelUpload = ({ field }) => {
  return (
    <>
      <Button
        color={field.color || "gray-line"}
        action={() => {
          document.getElementById(`excel-Input-${field.key}`).click();
        }}
        {...field}
        label={
          <>
            {field.label || "파일 선택"}
            <i className="mdi mdi-arrow-expand-up" />
          </>
        }
      />
      <input
        className="excel-input display-none"
        id={`excel-Input-${field.key}`}
        name={`excel-Input-${field.key}`}
        type="file"
        accept={
          get(field.options, "accept") ||
          "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
        onChange={(e) => {
          field.onChange(e);
        }}
        onClick={(e) => {
          const { target = {} } = e || {};
          target.value = "";
        }}
      />
    </>
  );
};
export default ExcelUpload;
